import {
  mode,
  StyleFunctionProps,
  transparentize,
} from "@chakra-ui/theme-tools";

const variants = {
  outline: (props: StyleFunctionProps) => ({
    borderRadius: "lg",
    bg: mode("white", "gray.800")(props),
    _hover: { borderColor: mode("gray.300", "gray.600")(props) },
    _focus: {
      borderColor: mode("brand.500", "brand.200")(props),
      boxShadow: mode(
        `0px 0px 0px 1px ${transparentize(`brand.500`, 1.0)(props.theme)}`,
        `0px 0px 0px 1px ${transparentize(`brand.200`, 1.0)(props.theme)}`,
      )(props),
    },
  }),
  "outline-accent": {
    bg: "white",
    borderRadius: "lg",
    color: "fg-main",
    borderWidth: "1px",
    borderColor: "fg-accent",
    _placeholder: {
      color: "gray.500",
    },
    _hover: {
      borderColor: "fg-accent",
    },
    _focus: {
      borderColor: "fg-accent",
    },
  },
  custom: {
    _placeholder: {
      color: "gray",
    },
    background: "white",
    backgroundColor: "white",
    border: "none",
    borderColor: "none",
    borderRadius: "lg",
    color: "black",
  },
  "th-outline": {
    background: "white",
    backgroundColor: "white",
    border: "1px solid",
    borderColor: "th.gray2",
    borderRadius: "sm",
    _placeholder: {
      color: "gray",
    },
  },
  "th-text-input": (props: StyleFunctionProps) => ({
    _placeholder: {
      color: "th.gray4",
    },
    _focus: {
      borderColor: props.isInvalid ? "th.danger1" : "th.actionLavender2",
      boxShadow: props.isInvalid
        ? "initial"
        : "0px 1px 2px 0px var(--chakra-colors-newLavender-100)",
    },
    border: props.isInvalid ? "2px solid" : "1px solid",
    borderColor: props.isInvalid ? "th.danger1" : "th.cream3",
    borderRadius: "lg",
    fontFamily: "Moderat",
    fontWeight: "light",
    fontSize: "1.125rem",
    h: "7.5rem",
    lineHeight: "120%",
    letterSpacing: "0",
  }),
  "th-short-text": (props: StyleFunctionProps) => ({
    field: {
      _placeholder: {
        color: "th.gray4",
      },
      _focus: {
        borderColor: props.isInvalid ? "th.danger1" : "th.actionLavender2",
        boxShadow: props.isInvalid
          ? "initial"
          : "0px 1px 2px 0px var(--chakra-colors-newLavender-100)",
      },
      border: props.isInvalid ? "2px solid" : "1px solid",
      borderColor: props.isInvalid ? "th.danger1" : "th.cream3",
      borderRadius: "lg",
      fontFamily: "Moderat",
      fontWeight: "light",
      fontSize: "1.125rem",
      lineHeight: "140%",
      letterSpacing: "0",
    },
  }),
};

export const Textarea = {
  variants,
  defaultProps: {
    color: "fg-main",
    variant: "custom",
  },
};
